<template>
    <div>
        <div class="tabulation-title mb-4">
            <h5>
                <v-icon color="primary">label_outline</v-icon> Général
            </h5>
        </div>

        <div class="mr-auto ml-auto">
            <v-text-field v-model="provider.name" label="Nom de votre activité" autocomplete="new-offer-name" outlined>
            </v-text-field>

            <v-select label="Catégorie"
                      v-if="quebecCategories.length > 0"
                      outlined
                      :items="quebecCategories"
                      @change="selectQcCategory"
                      return-object
                      item-text="label">
            </v-select>

            <v-select label="Catégorie"
                      v-else
                      outlined
                      :items="categories"
                      v-model="provider.category"
                      return-object
                      item-text="label">
            </v-select>

            <v-alert type="error" v-if="(provider.category !== null && provider.category.name === 'UNDEFINED') || provider.category === null">
                La catégorie de la fiche n'est pas définie.
                Il est obligatoire de sélectionner une catégorie pour créer une fiche.
            </v-alert>
        </div>
    </div>
</template>

<script>
import { mapState } from "vuex"

export default {
    name: "General",
    props: ["provider"],
    computed: {
        ...mapState('resource', ['categories', 'quebecCategories']),
        ...mapState('account', [ 'account']),
    },
    methods: {
        selectQcCategory(value) {
            const category = this.categories.find(cat => cat.name === value.code)

            if (category) {
                this.provider.category = category
                this.provider.qcCategory = value.label
            }
        }
    },
    created() {
        if (this.account.tis_type.code == 'DAHUB_QUEBEC') {
            this.provider.category = null
        }

    }
}
</script>
